import DimensionType from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
  list: {
    loading: true,
    data: []
  },
  frameType: {
    loading: true,
    data: []
  },
  dimensionCategory: {
    loading: true,
    data: []
  },
}

const Dimension = (state = INIT_STATE, action) => {
  switch (action.type) {
    case DimensionType.GET_DIMENSION_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case DimensionType.GET_DETAIL_DIMENSION_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case DimensionType.PUT_DIMENSION_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case DimensionType.POST_DIMENSION_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }

    case DimensionType.GET_DIMENSION_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload,
      }
    case DimensionType.GET_DIMENSION_FRAME_TYPE_SUCCESS:
      return {
        ...state,
        frameType: action.payload,
      }
    case DimensionType.GET_DIMENSION_LIST_CATEGORY_SUCCESS:
      return {
        ...state,
        dimensionCategory: action.payload,
      }

    default:
      return state
  }
}

export default Dimension
